import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { Base64Page } from "@/tools/base64-tool/pages/Base64Page";

const PATH = "/base64";

export const Route = createFileRoute("/base64")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.b64_meta_title() },
      { name: "description", content: m.b64_meta_description() },
      { property: "og:title", content: m.b64_meta_title() },
      { property: "og:description", content: m.b64_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.b64_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.b64_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: m.b64_faq1_q(),
              acceptedAnswer: { "@type": "Answer", text: m.b64_faq1_a() },
            },
            {
              "@type": "Question",
              name: m.b64_faq2_q(),
              acceptedAnswer: { "@type": "Answer", text: m.b64_faq2_a() },
            },
            {
              "@type": "Question",
              name: m.b64_faq3_q(),
              acceptedAnswer: { "@type": "Answer", text: m.b64_faq3_a() },
            },
            {
              "@type": "Question",
              name: m.b64_faq4_q(),
              acceptedAnswer: { "@type": "Answer", text: m.b64_faq4_a() },
            },
          ],
        }),
      },
    ],
  }),
  component: Base64Page,
});
